"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _polished = require("polished");

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 0 3rem 2rem;\n  border-top: 2px solid ", ";\n  background: white;\n"])), function (props) {
  return props.theme.colorBorder;
});

var StyledRow = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-start;\n  margin-bottom: 1rem;\n"])));

var StyledLeft = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  flex: 8;\n  margin-right: 1rem;\n"])));

var StyledRight = _styledComponents.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  flex: 4;\n"])));

var StyledNumber = _styledComponents.default.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 60px;\n  height: 60px;\n  margin: 0 auto;\n  font-weight: 700;\n  border-radius: 50%;\n  border: 5px solid ", ";\n  background: ", ";\n  color: #d3d5d8;\n  transform: translateY(-25px);\n"])), function (props) {
  return props.theme.colorLightGrey;
}, function (p) {
  return p.theme.colorSkeleton;
});

var ContestPicksSkeleton = function ContestPicksSkeleton(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_fiverReactUiComponents.Card, {
    style: {
      paddingTop: 0
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledNumber, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledRow, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledLeft, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.Skeleton, {
            skeletonHeight: "20px",
            skeletonWidth: "180px",
            skeletonBorderRadius: "0.25rem",
            margin: "0 0 6px"
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.Skeleton, {
            skeletonHeight: "20px",
            skeletonBorderRadius: "0.25rem",
            skeletonWidth: "120px",
            margin: "0 0 6px"
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.Skeleton, {
            skeletonHeight: "20px",
            skeletonWidth: "70px",
            skeletonBorderRadius: "0.25rem",
            margin: "0 0 12px"
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.Skeleton, {
          skeletonHeight: "12px",
          skeletonWidth: "90px",
          skeletonBorderRadius: "0.25rem",
          margin: "0 0 16px"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.Skeleton, {
            skeletonHeight: "58px",
            skeletonWidth: "100%"
          })
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledRight, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.Skeleton, {
          skeletonHeight: "90px",
          skeletonWidth: "90px",
          margin: "0 0 30px"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.Skeleton, {
          skeletonHeight: "58px",
          skeletonWidth: "100%"
        })]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.Skeleton, {
      skeletonHeight: "50px",
      skeletonWidth: "100%",
      margin: "0 0 0.5rem"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.Skeleton, {
      skeletonHeight: "50px",
      skeletonWidth: "100%"
    })]
  });
};

var _default = ContestPicksSkeleton;
exports.default = _default;